import SettingSection from '../components/SettingSection';

const Settings = () => {
  return <SettingSection />;
};

export default Settings;
